var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.576,
    height: 62.576,
    viewBox: "0 0 62.576 62.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2474",
    "data-name": "Groupe 2474",
    transform: "translate(-1096.924 -730.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2900",
    "data-name": "Trac\\xE9 2900",
    d: "M61.576,30.789A30.788,30.788,0,1,1,30.788,0,30.788,30.788,0,0,1,61.576,30.789",
    transform: "translate(1097.424 730.999)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2901",
    "data-name": "Trac\\xE9 2901",
    d: "M109.04,124.99c-1.539-8.1,8.206-12.925,13.951-7.078a20.535,20.535,0,0,0,4.821-2.154,8.873,8.873,0,0,1-3.59,4.513,15.288,15.288,0,0,0,4.411-1.231,8.574,8.574,0,0,1-3.8,3.8c1.333,18.567-18.669,29.85-34.877,20.618,0,0,8,.41,11.386-3.488,0,0-4.924.41-7.386-5.539a4.948,4.948,0,0,0,3.693-.205s-5.744-.923-6.257-7.8a5.055,5.055,0,0,0,3.9.923s-6.36-3.8-2.77-10.668c0,0,6.77,8.616,16.515,8.309",
    transform: "translate(1019.018 630.67)",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.90729ebadb5cd407e789d03182fdd205.svg";
export { ForwardRef as ReactComponent };